import React, { useCallback } from 'react';
import { Button } from './styled';
import { StyledIcon as PlayerIcon } from '../../../../../../Icons';
export const BackButton = ({ onBack, className, backgroundColor, }) => {
    const handleClick = useCallback((event) => {
        if (!onBack)
            return;
        onBack();
        event.stopPropagation();
        event.preventDefault();
    }, [onBack]);
    return (React.createElement(Button, { onClick: handleClick, "data-test": "BackButton-Button", testID: "back_button", test: "test", className, backgroundColor },
        React.createElement(PlayerIcon, { "data-test": "BackButton-Icon", className: "BackButton-Icon", name: "onDark-back", backgroundColor })));
};
BackButton.displayName = 'BackButton';
BackButton.defaultProps = {
    backgroundColor: 'transparent',
    className: '',
};
//# sourceMappingURL=index.js.map